<template>
  <router-link
    class="ui card"
    :to="destination"
  >
    <div class="image">
      <img class="poster" v-lazy="url" style="height: 16rem; width: 100%;">
    </div>
    <div class="content">
      <div class="header">
        {{ name }}
      </div>
      <div class="content">
        <div class="summary" />
      </div>
      <div class="extra content">
        <span class="right floated" />
        <span />
      </div>
    </div>
  </router-link>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'CameraView',
  props: ['name', 'cameraId'],
  computed: {
    ...mapGetters(['authToken']),
    destination: function () {
      return `/view/${this.cameraId}/:undefined`
    },
    url () {
      return `https://svc-a.api.owal.io/api/snapshot/v1/snapshot/${this.cameraId}?token=${this.authToken}`
    },
  },
}
</script>

<style scoped>

</style>
